module.exports = __webpack_public_path__ + "static/media/34.b4712a1d.avif";